<template>
  <!-- bouton d'accès à la modal -->
  <div class="md-layout-item md-small-size-100">
    <div class="md-layout">
      <div class="md-layout-item md-size-33 md-xsmall-size-100">
        <md-button class="md-warning" @click="classicModal = true">
          <md-icon>share</md-icon> {{ $t("share") }}
        </md-button>
        <div class="modal modal-bg" :class="{ show: classicModal }">
          <modal> </modal>
        </div>
      </div>
    </div>
    <!-- bloc de modal -->
    <div class="md-layout-item md-size-33">
      <modal
        style="margin-left: auto;margin-right: auto;"
        id="modal"
        v-if="classicModal"
        @close="classicModalHide"
      >
        <template slot="header">
          <h4 class="modal-title">{{ $t("share") }}</h4>
          <md-button
            class="md-simple md-just-icon md-round modal-default-button"
            @click="classicModalHide"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <div class="row w-100 md-auto">
            <md-button
              :class="`${activeBtnShare} md-just-icon md-round`"
              class="md-raised"
              @click="replaceLink"
              ><md-icon>share</md-icon></md-button
            >

            <md-button
              :class="`${activeBtnEmbed} md-just-icon md-round`"
              class="md-raised"
              isActive
              @click="replaceCode"
              ><md-icon>code</md-icon></md-button
            >
          </div>

          <md-field class="card-body text-muted">
            <p>
              <code class="text-muted" id="link">{{ urlToCopy }}</code>
            </p>
          </md-field>
        </template>

        <template slot="footer">
          <md-button class="md-primary" @click="copyLink">Copy</md-button>
          <md-button
            class="md-button md-theme-default md-info"
            @click="classicModalHide"
            >Close</md-button
          >
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import componentMixin from "ireal-vue/mixins/component-mixin.js";
import Modal from "vue-material-kit-pro/src/components/Modal.vue";

export default {
  name: "share-widget",
  mixins: [componentMixin],
  components: { Modal },
  props: ["identifier"],
  data() {
    return {
      showDialog: false,
      classicModal: false,
      urlToCopy: window.location.href,
      activeBtnShare: "md-primary",
      activeBtnEmbed: "md-white"
    };
  },
  computed: {
    idModal() {
      return this.attributes.id ? this.attributes.id : "modal-1";
    }
  },
  methods: {
    classicModalHide() {
      this.classicModal = false;
    },
    copyLink() {
      var toCopy = document.getElementById("link").innerText;
      var elem = document.createElement("textarea");
      document.body.appendChild(elem);
      elem.value = toCopy;
      elem.select();
      document.execCommand("copy");
      document.body.removeChild(elem);
    },
    replaceLink() {
      this.urlToCopy = window.location.href;
      this.activeBtnShare = "md-primary";
      this.activeBtnEmbed = "md-white";
    },
    replaceCode() {
      var heightPageExperience = document.documentElement.scrollHeight;
      var widthPageExperience = document.documentElement.clientWidth;
      var heightForIframe = (heightPageExperience / widthPageExperience) * 100;
      this.activeBtnShare = "md-white";
      this.activeBtnEmbed = "md-primary";
      var location = window.location.href;
      var locarray = location.split("/");
      delete locarray[locarray.length - 1];
      locarray.splice(3, 1, "emb");
      var arraytext = locarray.join("/");
      this.urlToCopy = `<iframe src="${arraytext}${this.identifier}" scrolling="yes" style="width: 100%; height: ${heightForIframe}%; display: block;left:0px;top:0px;" frameborder="0"></iframe>`;
    }
  }
};
</script>
<style scoped>
#modal {
  position: fixed;
  z-index: 999;
}
p,
code {
  line-height: 1em !important;
}
</style>
